import { useEnhancedQuery } from "@uplift-ltd/apollo";
import { SubscriptionProductsQueryQuery } from "components/Subscriptions/__generated__/queries";
import { SUBSCRIPTION_PRODUCTS_QUERY } from "components/Subscriptions/queries";

export const useSubscriptionProducts = () => {
  return useEnhancedQuery<SubscriptionProductsQueryQuery>(SUBSCRIPTION_PRODUCTS_QUERY);
};
